import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { publicToolHead } from "@/lib/publicToolRoutes";

const Page = () => <Index toolKey="music" routeLang="en" />;

export const Route = createFileRoute("/en/music-for-your-store")({
  head: () => publicToolHead("music", "en"),
  component: Page,
  errorComponent: Page,
  notFoundComponent: Page,
});
